import { connect } from '../../../../common/react-redux';
import { closeTray } from '../../../../common/actions/moderation';
import ModerateTrayPresenter from './presenter';
export function mapStateToProps(state) {
  return {
    isOpen: state.getIn(['moderation', 'trayOpen']) || false,
    participantName: state.getIn(['moderation', 'selectedParticipantName'])
  };
}
export default connect(mapStateToProps, {
  closeTray: closeTray
})(ModerateTrayPresenter);